import React, { useState } from "react";
import { Box, Button, IconButton, Input, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from '@mui/icons-material/Edit';
import { CloseOutlined } from '@mui/icons-material';
import CustomSelect from "../../../Components/CustomSelect";
import ModalForms from "../../../Components/Simple Purchase/ModalForms";
import CustomButton from "../../../Components/CustomButton";
import Approve from '../../../assets/Approve.png'
import CustomInput from "../../../Components/CustomInput";
import Setting from '../../../assets/Setting.png'
const CreditNoteTable = () => {
  const [openModal, setOpenModal] = useState(false);
  const [rows, setRows] = useState([{ id: 1, product: "", reference: "", quantity: 1, price: 0, discount: 0, taxRule: "", account: "", total: 0,}]);

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        product: "",
        reference: "",
        quantity: 1,
        price: 0,
        discount: 0,
        taxRule: "",
        account: "",
        total: 0,
      },
    ]);
  };
  const products = [
    { id: 1, name: "Product A", price: 10 },
    { id: 2, name: "Product B", price: 15 },
];
  const productOptions = [
    ...products.map((p) => ({ label: p.name, value: p.name })),
    { label: ' Add new item', value: '__add_new__', isSpecial: true }
  ];
  const modalFields = [
    // Mandatory Terms
    { key: 'sku', label: 'SKU', type: 'text', required: true, width: { xs: '100%', md: "49%" } },
    { key: 'unitOfMeasure', label: 'Unit of Measure', type: 'select', data: ['each', 'g', 'oz'], required: true, width: { xs: '100%', md: "49%" } },
    { key: 'name', label: 'Name', type: 'text', required: true, width: { xs: '100%', md: "49%" } },
    { key: 'costingMethod', label: 'Costing Method', type: 'select', data: ['FIFO', 'FIFO by Serial Number', 'FIFO by Batch', 'FEFO by Serial Number', 'FEFO by Batch'], required: true, width: { xs: '100%', md: "49%" } },
    { key: 'type', label: 'Type', type: 'select', data: ['Non-Inventory', 'Stock', 'Fixed Asset'], required: false, width: { xs: '100%', md: "49%" } },
    { key: 'expenseAccount', label: 'Expense Account', type: 'text', required: false, width: { xs: '100%', md: "49%" } },
    { key: 'category', label: 'Category', type: 'select', data: ['Other'], required: true, width: { xs: '100%', md: "49%" } },

    // Non-Mandatory Terms
    { key: 'minBeforeReorder', label: 'Minimum before reorder', type: 'text', required: false, width: { xs: '100%', md: "49%" } },
    { key: 'purchaseTaxRule', label: 'Purchase Tax Rule', type: 'select', data: ['a'], required: false, width: { xs: '100%', md: "49%" } },
    { key: 'reorderQty', label: 'Reorder Quantity', type: 'text', required: false, width: { xs: '100%', md: "49%" } },
    { key: 'salesTaxRule', label: 'Sales Tax Rule', type: 'select', data: ['PST', 'GST', 'PST/GST', 'HST', 'Tax Exempt'], required: false, width: { xs: '100%', md: "49%" } },
    { key: 'barCode', label: 'Bar Code', type: 'text', required: false, width: { xs: '100%', md: "49%" } },
    { key: 'storeLocator', label: 'Store Locator', type: 'text', required: false, width: { xs: '100%', md: "49%" } },
    { key: 'attributeSet', label: 'Attribute Set', type: 'select', data: ['Licensed Producer', 'Brand', 'Potency', 'GTIN#'], required: false, width: '100%' },
];
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    // Auto calculate total
    const quantity = parseFloat(updatedRows[index].quantity) || 0;
    const price = parseFloat(updatedRows[index].price) || 0;
    const discount = parseFloat(updatedRows[index].discount) || 0;
    let total = quantity * price;

    if (discount > 0) {
      total = total - (total * discount) / 100;
    }
    updatedRows[index].total = total.toFixed(2);

    setRows(updatedRows);
  };
  const handleProductChange = (id, value) => {
    const selectedProduct = products.find((product) => product.name === value);
      setRows(
          rows.map((item) =>
              item.id === id
                  ? { ...item, product: value, price: selectedProduct ? selectedProduct.price : "", total: selectedProduct ? selectedProduct.price * item.quantity : "" }
                  : item
          )
      );
  };
  const handleSave = (formValues) => {
    setOpenModal(false);
};

  const handleDeleteRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  return (
    <Box sx={{ bgcolor: "white", borderRadius: "10px"}}>
      <div style={{ borderBottom: '1px solid #38535E' }}>
        <Typography sx={{ paddingX: 1, paddingY: 2, fontSize: "16px" }}>CREDIT NOTE</Typography>
      </div>
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between',alignContent: 'center', pb: 2, p: 2 }}>

      <IconButton onClick={handleAddRow}>
        <Box sx={{ border: "1px solid #95ABEB", borderRadius: '5px', width: "30px", height: "30px", display: 'flex', justifyContent: "center", p: 1 }}>
          <AddIcon sx={{ color: "#95ABEB" }} />
        </Box>
      </IconButton>
      <CustomButton text={"Approve"} bgcolor={"#95ABEB"} color={"black"} img={Approve} />
      </Box>
      <TableContainer sx={{ borderRadius: 2, border: "1px solid", overflow: 'scroll', mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><img src={Setting} style={{ filter: 'invert()', width: "30px" }} alt='setting' /></TableCell>
              <TableCell>PRODUCT</TableCell>
              <TableCell>REFERENCE</TableCell>
              <TableCell>QUANTITY</TableCell>
              <TableCell>PRICE</TableCell>
              <TableCell>DISCOUNT</TableCell>
              <TableCell>TAX RULE</TableCell>
              <TableCell>ACCOUNT</TableCell>
              <TableCell>TOTAL</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan="9" align="center">
                  You do not have any credit note lines.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={index}>
                   <TableCell>
                      <IconButton 
                      // onClick={() => removeItem(item.id)}
                      >
                          <EditIcon />
                      </IconButton>
                  </TableCell>
                  <TableCell sx={{ width: '30%' }}>
                    <CustomSelect
                      // minWidth='100px'
                      name="product"
                      value={row.product}
                      data={productOptions}
                      handleChange={(e) => handleProductChange(row.id, e.target.value)}
                      handleAddClick={() => setOpenModal(true)}
                      searchable
                      placeholder='Type to search...'
                      
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      value={row.reference}
                      onChange={(e) => handleInputChange(index, "reference", e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      type="number"
                      value={row.quantity}
                      onChange={(e) => handleInputChange(index, "quantity", e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      type="number"
                      value={row.price}
                      onChange={(e) => handleInputChange(index, "price", e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      type="number"
                      value={row.discount}
                      onChange={(e) => handleInputChange(index, "discount", e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      value={row.taxRule}
                      onChange={(e) => handleInputChange(index, "taxRule", e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      value={row.account}
                      onChange={(e) => handleInputChange(index, "account", e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell align="right">{row.total}</TableCell>
                  <TableCell align="center">
                    <Button variant="outlined" color="error" onClick={() => handleDeleteRow(index)}>
                      <CloseOutlined />
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <Button sx={{ fontSize: "12px" }} onClick={handleAddRow} startIcon={<AddIcon />}>
          Add more items
        </Button>
      </TableContainer>
      {/* Summary */}
      <Box sx={{ display: { xs: "block", md: "flex" }, justifyContent: "space-between", mt: 3, gap: 2, }}>
        {/* Credit Note Memo */}
        <Box sx={{ minWidth: "50%" }}>
          <CustomInput label={"Credit Note Memo"} height={"200px"} multiline />
        </Box>

          {/* Styled Summary Box */}
          <TableContainer
            className="table"
            sx={{
              borderRadius: 2,
              border: "1px solid #000",
              overflow: "hidden", // no scroll needed for static summary
              mt: 2,
              // minHeight: "200px",
            }}
          >
            <Table>
              {/* Header - TOTAL */}
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="right"
                    sx={{ fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #000", padding: "12px"}}
                  >
                    TOTAL
                  </TableCell>
                </TableRow>
              </TableHead>
                  
              {/* Body */}
              <TableBody>
                <TableRow>
                  <TableCell
                    align="right"
                    sx={{ borderBottom: "none", color: "gray", padding: "10px" }}
                  >
                    BEFORE TAX
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ borderBottom: "none", padding: "10px" }}
                  >
                    0.00
                  </TableCell>
                </TableRow>
                  
                <TableRow>
                  <TableCell
                    align="right"
                    sx={{ borderBottom: "none", color: "gray", padding: "10px" }}
                  >
                    TAX
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ borderBottom: "none", padding: "10px" }}
                  >
                    0.00
                  </TableCell>
                </TableRow>
                  
                <TableRow>
                  <TableCell
                    align="right"
                    sx={{
                      borderBottom: "none",
                      fontWeight: "bold",
                      padding: "12px 10px 4px 10px",
                    }}
                  >
                    TOTAL
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontWeight: "bold",
                      padding: "12px 10px 4px 10px",
                      borderBottom: "none"
                    }}
                  >
                    0.00
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <CustomButton text={"Save"} bgcolor={'#95ABEB'} color={'black'} />
        </Box>

      
      {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <CustomButton text={"Save"} bgcolor={'#95ABEB'} color={'black'} />
      </Box> */}
      <ModalForms
        open={openModal}
        setOpen={setOpenModal}
        data={modalFields}
        name="Add a new Product"
        handleSave={handleSave}
      />
      </Box>
    </Box>
  );
};

export default CreditNoteTable;
  